import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {adminAction, GetSubordinateAssignedRolesAction} from '../action';

const tableId = 'roleSubordinateAssignedRoles';

function* execute(action: GetSubordinateAssignedRolesAction): SagaIterator {
    const {tableDataRequest, roleId} = action.payload;
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.getSubordinateRoles,
        successAction: adminAction.getSubordinateAssignedRolesSuccess,
        tableId,
        pathParams: {
            roleId,
        },
    }));
}

/** Runs the admin saga that loads subordinate roles already assigned to the selected role. */
export function* getSubordinateAssignedRolesSaga(): SagaIterator {
    yield takeLatestF('admin/GET_SUBORDINATE_ASSIGNED_ROLES', execute);
}
